import { RiderDayEnum } from '../enums/weekRiderEnum';

export const getCurrentRiderDay = (): RiderDayEnum => {
  const currentDate = new Date();
  const dayOfMonth = currentDate.getDate();

  if (dayOfMonth >= 1 && dayOfMonth <= 7) {
    return RiderDayEnum.ONE_SEVEN;
  } else if (dayOfMonth >= 8 && dayOfMonth <= 14) {
    return RiderDayEnum.EIGHT_FOURTEEN;
  } else if (dayOfMonth >= 15 && dayOfMonth <= 21) {
    return RiderDayEnum.FIFTEEN_TWENTY_ONE;
  } else {
    return RiderDayEnum.TWENTY_TWO_MORE;
  }
};
